import { sendLoggingInformation } from "../sendLoggingInformation";
import { EnumActionNameLevel1, EnumActionNameLevel2, EnumActionNameLevel3, EnumGeneratedBy, EnumUxTypes, Cart} from "../types/LoggingTypes";
import { updateActionHistory } from "./updateActionHistory";
import { updateWidgetHistory } from "./updateWidgetHistory";

const logScreenLoad = (cart : Cart) => {
      updateActionHistory(EnumActionNameLevel1.SCREEN, EnumActionNameLevel2.LOAD, EnumActionNameLevel3.SUCCESS);
      updateWidgetHistory('')
      sendLoggingInformation(EnumUxTypes.SCREEN, EnumGeneratedBy.USER, 'cart', cart.id);
  }

  const logOrderStartClick = (cart : Cart) => {
      updateActionHistory(EnumActionNameLevel1.ORDER, EnumActionNameLevel2.START, EnumActionNameLevel3.CLICK);
      updateWidgetHistory('')
      sendLoggingInformation(EnumUxTypes.BUTTON, EnumGeneratedBy.USER, 'cart', cart.id);
  }

  const logOrderProductsAddToCart = (cart : Cart) => {
      updateActionHistory(EnumActionNameLevel1.ORDER, EnumActionNameLevel2.PRODUCTS, EnumActionNameLevel3.CLICK_ADD_TO_CART);
      updateWidgetHistory('')
      sendLoggingInformation(EnumUxTypes.BUTTON, EnumGeneratedBy.USER, 'cart', cart.id);
  }
  
  const logOrderCartReviewView = (cart : Cart) => {
    setTimeout(()=>{
      updateActionHistory(EnumActionNameLevel1.ORDER, EnumActionNameLevel2.CART_REVIEW, EnumActionNameLevel3.VIEW);
      updateWidgetHistory('')
      sendLoggingInformation(EnumUxTypes.SCREEN, EnumGeneratedBy.USER, 'cart', cart.id);
    }, 50)
  }
  
  const logOrderCartReviewSelectPayment = (cart : Cart) => {
        updateActionHistory(EnumActionNameLevel1.ORDER, EnumActionNameLevel2.CART_REVIEW, EnumActionNameLevel3.CLICK_SELECT_PAYMENT);
        updateWidgetHistory('')
        sendLoggingInformation(EnumUxTypes.BUTTON, EnumGeneratedBy.USER, 'cart', cart.id);
  }

  const logOrderSelectPaymentView = (cart : Cart) => {
    setTimeout(()=>{
      updateActionHistory(EnumActionNameLevel1.ORDER, EnumActionNameLevel2.SELECT_PAYMENT, EnumActionNameLevel3.VIEW);
      updateWidgetHistory('')
      sendLoggingInformation(EnumUxTypes.SCREEN, EnumGeneratedBy.USER, 'cart', cart.id);
    }, 300)

  }

  const logOrderSelectPaymentClickPay = (cart : Cart, payment : string = 'NA') => {
      updateActionHistory(EnumActionNameLevel1.ORDER, EnumActionNameLevel2.SELECT_PAYMENT, EnumActionNameLevel3.CLICK_PAY);
      updateWidgetHistory('')
      sendLoggingInformation(EnumUxTypes.BUTTON, EnumGeneratedBy.USER, 'cart', cart.id,payment);
  }

  const logOrderEndSuccess = (cart : Cart) => {
    updateActionHistory(EnumActionNameLevel1.ORDER, EnumActionNameLevel2.END, EnumActionNameLevel3.SUCCESS);
    updateWidgetHistory('')
    sendLoggingInformation(EnumUxTypes.SCREEN, EnumGeneratedBy.USER, 'cart', cart.id);
  }

  const logOrderEndFail = (cart : Cart) => {
    updateActionHistory(EnumActionNameLevel1.ORDER, EnumActionNameLevel2.END, EnumActionNameLevel3.FAIL);
    updateWidgetHistory('')
    sendLoggingInformation(EnumUxTypes.SCREEN, EnumGeneratedBy.USER, 'cart', cart.id);
  }

  const logPermissionLocationAllow = ()=>{
    updateActionHistory(EnumActionNameLevel1.PERMISSION, EnumActionNameLevel2.LOCATION, EnumActionNameLevel3.ALLOW);
    updateWidgetHistory('');
    sendLoggingInformation(EnumUxTypes.NA, EnumGeneratedBy.USER);
  }

  const logPermissionLocationDeny = ()=>{
    updateActionHistory(EnumActionNameLevel1.PERMISSION, EnumActionNameLevel2.LOCATION, EnumActionNameLevel3.DENY);
    updateWidgetHistory('');
    sendLoggingInformation(EnumUxTypes.NA, EnumGeneratedBy.USER);
  }
  
export {logPermissionLocationAllow, logPermissionLocationDeny,logScreenLoad, logOrderStartClick, logOrderProductsAddToCart, logOrderCartReviewView, logOrderCartReviewSelectPayment, logOrderEndFail, logOrderEndSuccess, logOrderSelectPaymentClickPay, logOrderSelectPaymentView}